<template>
  <ModalConfirmAction
    title="Excluir palavra bloqueada"
    message="Tem certeza que deseja remover esta palavra bloqueada?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="removerPalavraBloqueada"
  >
    <template #activator="{ on, attrs }">
      <div class="table-action-box table-action-delete" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
        <span class="table-action-label">Excluir</span>
      </div>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  name: "ModalExcluirPalavraBloqueada",
  components: { ModalConfirmAction },
  props: {
    getPalavrasBloqueadas: Function,
    cod_palavra_bloqueada: Number,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async removerPalavraBloqueada() {
      try {
        this.loading = true;
        const response = await apiClient.delete(`/removerPalavraBloqueada/${this.cod_palavra_bloqueada}`);

        if (response.status === 200) {
          await this.getPalavrasBloqueadas();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || "Erro ao remover palavra.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
